/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Team from 'assets/images/hero/team.jpeg';  

export default function HeroTeam() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row">

      <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
        <Fade direction="up" triggerOnce>
          <h1 className="text-6xl text-theme-blue font-bold leading-tight mb-5">
            Chief Executive Officer
          </h1>
        </Fade>
        <Fade direction="up" delay={500} triggerOnce>
          <p className="font-light text-xl text-gray-400 leading-relaxed">
            My Name Muhammad Amin Iqbaal Alam, graduate Bachelor Technology of Brawijaya University. I've Certified IT Project Manager, AK3U, Data Science & Software Engineer.
          </p>
        </Fade>
      </div>
      <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
        <div className='text-center w-full max-w-[550px] mx-auto mb-[50px]'>
          <Fade direction="top-right" triggerOnce delay={300}>
            <img 
              src={Team} 
              alt="Hero" 
              className="w-full h-auto rounded-3xl shadow-xl border border-gray-100" 
            />
          </Fade>
        </div>
      </div>
    </section>
  );
}
